export class SubSectionDto {
  public IsComplete: boolean;
  public HasBusinessValidationErrors: boolean;
  public HasFullValidationErrors: boolean;
}
